import { AccessWithoutMandatoryParamsHOC } from "app/components/React/HOCs/accessWithoutMandatoryParamsHOC";
import { withAllContextHoc } from "app/components/React/HOCs/withAllContextsHOC";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { BacklinksModuleFrame } from "app/pages/digital-marketing/backlinks/frame/BacklinksModuleFrame";
import { BacklinksTableReport } from "app/pages/digital-marketing/backlinks/reports/backlinks/BacklinksTableReport";
import { BacklinksDomainsReport } from "app/pages/digital-marketing/backlinks/reports/domains/BacklinksDomainsReport";
import { BacklinksOverviewReport } from "app/pages/digital-marketing/backlinks/reports/overview/BacklinksOverviewReport";
import { onRedirectBacklinksDuration } from "app/pages/digital-marketing/backlinks/user-route/onRedirectBacklinksDuration";
import { onRedirectBacklinksExactUrl } from "app/pages/digital-marketing/backlinks/user-route/onRedirectBacklinksExactUrl";
import { onRedirectBacklinksKey } from "app/pages/digital-marketing/backlinks/user-route/onRedirectBacklinksKey";
import { QualificationSideBarContainer } from "app/pages/website-analysis/components/qualification-sidebar/QualificationSideBarContainer";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

const WORLD_WIDE = "999";

export const backlinksConfig: RouterStateConfig = {
    digitalsuite_backlinks_root: {
        parent: "digitalsuite_acquisition_root",
        url: "/backlinks",
        component: withAllContextHoc(BacklinksModuleFrame),
        pageTitle: "digitalsuite.backlinks",
        secondaryBarType3: SecondarySideBarType3.BacklinksAnalysis,
        abstract: true,
        data: {
            getCustomUrlType: () => {
                return "website";
            },
        },
    },
    digitalsuite_backlinks_overview: {
        parent: "digitalsuite_backlinks_root",
        name: "digitalsuite_backlinks_overview",
        url: `/overview/:country/?duration?key?pageFilter`,
        component: AccessWithoutMandatoryParamsHOC(BacklinksOverviewReport, "key"),
        resolve: [resolvers.siteInfo],
        stateNameForEductionBar: "digitalsuite_backlinks_overview",
        configId: "Backlinks",
        defaultQueryParams: {
            country: WORLD_WIDE,
        },
        params: {
            country: WORLD_WIDE,
            pageFilter: { dynamic: false },
            key: { dynamic: false },
        },
        reloadOnSearch: true,
        pageTitle: "digitalsuite.backlinks.overview.title",
        pageSubtitle: "digitalsuite.backlinks.overview.subtitle",
        icon: "sw-icon-nav-organic",
        trackingId: {
            section: "Backlinks Analytics",
            subSection: "Overview",
        },
        pageId: {
            section: "Acquisition",
            subSection: "Search/Backlinks Analytics",
            subSubSection: "Overview",
        },
        homeState: "digitalsuite_backlinks_root",
        skipDurationCheck: true,
        skipCountryCheck: true,
        redirectTo: redirectPipe(onRedirectBacklinksKey, onRedirectBacklinksDuration("365d")),
        hideCompareButton: true,
        hideFavoriteButton: true,
    },
    digitalsuite_backlinks_table: {
        parent: "digitalsuite_backlinks_root",
        name: "digitalsuite_backlinks_table",
        url: `/table/:country/?duration?key?new?lost?exactUrl?sort?asc?status?follow?dtsFrom?dtsTo?pageFilter?brokenOnly?includeExclude`,
        component: AccessWithoutMandatoryParamsHOC(BacklinksTableReport, "key"),
        resolve: [resolvers.siteInfo],
        stateNameForEductionBar: "digitalsuite_backlinks_table",
        configId: "Backlinks",
        defaultQueryParams: {
            country: WORLD_WIDE,
            sort: "DomainScore",
        },
        params: {
            country: WORLD_WIDE,
            key: { dynamic: false },
            new: { dynamic: false },
            lost: { dynamic: false },
            exactUrl: { dynamic: false },
            sort: { dynamic: true },
            asc: { dynamic: true },
            status: { dynamic: false },
            follow: { dynamic: false },
            dtsFrom: { dynamic: false },
            dtsTo: { dynamic: false },
            pageFilter: { dynamic: false },
            includeExclude: { dynamic: false },
            brokenOnly: { dynamic: true },
        },
        reloadOnSearch: false,
        pageTitle: "digitalsuite.backlinks.table.title",
        pageSubtitle: "digitalsuite.backlinks.table.subtitle",
        icon: "sw-icon-nav-organic",
        trackingId: {
            section: "Backlinks Analytics",
            subSection: "Backlinks",
        },
        pageId: {
            section: "Backlinks Analytics",
            subSection: "Backlinks",
        },
        homeState: "digitalsuite_backlinks_root",
        redirectTo: redirectPipe(
            onRedirectBacklinksKey,
            onRedirectBacklinksDuration("28d"),
            onRedirectBacklinksExactUrl,
        ),
        reset: {
            new: null,
            lost: null,
            exactUrl: null,
            sort: null,
            asc: null,
        },
        resetOnMainSiteChange: true,
        skipDurationCheck: true,
        skipCountryCheck: true,
        hideCompareButton: true,
        hideFavoriteButton: true,
    },
    digitalsuite_backlinks_domains: {
        parent: "digitalsuite_backlinks_root",
        name: "digitalsuite_backlinks_domains",
        url: `/domains/:country/?key?targetUrl?asc?sort?dtsFrom?dtsTo?pageFilter`,
        component: AccessWithoutMandatoryParamsHOC(BacklinksDomainsReport, "key"),
        resolve: [resolvers.siteInfo],
        stateNameForEductionBar: "digitalsuite_backlinks_domains",
        configId: "Backlinks",
        defaultQueryParams: {
            country: WORLD_WIDE,
            asc: false,
            sort: "BacklinksCount",
        },
        params: {
            country: WORLD_WIDE,
            asc: { dynamic: false },
            sort: { dynamic: false },
            dtsFrom: { dynamic: false },
            dtsTo: { dynamic: false },
            pageFilter: { dynamic: false },
            targetUrl: { dynamic: true },
        },
        reloadOnSearch: true,
        pageTitle: "digitalsuite.backlinks.refdomains.title",
        pageSubtitle: "digitalsuite.backlinks.refdomains.subtitle",
        icon: "sw-icon-nav-organic",
        trackingId: {
            section: "Backlinks Analytics",
            subSection: "Referring Domains",
        },
        pageId: {
            section: "Acquisition",
            subSection: "Search/Backlinks Analytics",
            subSubSection: "Referring_Domains",
        },
        homeState: "digitalsuite_backlinks_root",
        redirectTo: redirectPipe(onRedirectBacklinksKey),
        reset: {
            targetUrl: null,
        },
        resetOnMainSiteChange: true,
        qualificationSideBarComponent: QualificationSideBarContainer,
        skipDurationCheck: true,
        skipCountryCheck: true,
        hideCompareButton: true,
        hideFavoriteButton: true,
    },
};
